import { ITableRow } from '@makyoapp/makyo-sdk/models/Table'

import { workerRequest } from '@/workers/worker-request'

import { IDBTable } from '../table'

/**
 * Handle apply user filter for app builder components
 */
export async function applyUserFilter(
  requestId: string,
  rows: ITableRow[],
  table: IDBTable,
  filters: Record<string, any> | undefined
): Promise<ITableRow[]> {
  // get data worker
  const { dataWorker } = table.dbClient

  // If there's no filter, no settings, or no conditions, return all rows immediately.
  if (!filters || typeof filters !== 'object' || Object.keys(filters).length === 0) {
    return Promise.resolve(rows)
  }

  try {
    const response = await workerRequest<{ rows: ITableRow[] }>(dataWorker, {
      type: 'table-data-user-filter',
      requestId: `${requestId}-${Date.now()}`,
      data: { filters, rows, columns: table.settings._Columns },
    })

    return response.rows
    //
  } catch (err) {
    console.error('table-data-user-filter error: ', err)
    return Promise.resolve(rows)
  }
}
